import { SWITCH_STATE } from '@/config/switchStates';

export const MULTI_TIPS_MODES = [
  {
    name: 'Off',
    value: SWITCH_STATE.OFF,
  },
  {
    name: 'On',
    value: SWITCH_STATE.ON,
  },
  {
    name: 'On and set as default',
    value: 'DEFAULT_ON',
  },
];
